export default {
  'guesssYouLike':	'You may like',
  'actorExhibitListText': ['Representative products', 'New product', 'High-end products'],
  'actorExhibitTip': ['You are temporarily unable to view new products, please go to', 'You are temporarily unable to view High-end products, please go to'],
  'lookMore': 'View more products',
  'registerText': 'Register',
  'actorIndex': 'Data analyse', 
  'personReport': 'Exhibition report',
  'actorBase': 'Basic Exhibitor Data',
  'prodcutStatistics': 'Exhibits Statistics',
  'opporStatistics': 'News Feeds statistics',
  'inviteStatistics': 'Invitation Statistics',
  'IMStatistics': 'IM statistics',
  'collectedStatistics': 'Collection statistics',
  'visitStatistics': 'Browse statistics',
  'subTitle':  'Click on the statistics module below to view the corresponding audience details',
  'subTitle2': 'Click the statistics module below to view the corresponding indicator details',
  'subTitle3': 'Click on the statistics module below to view the details of the corresponding News Feeds',
  'subTitle4': 'Click on the statistics module below to view the corresponding invitation details',
  'subTitle5': 'Click on the statistics module below to view the corresponding IM details',
  'look': 'The number of views',
  'lookSub': 'The total number of times the exhibitor was viewed',
  'lookSub2': 'The total number of times the exhibit has been viewed',
  'visit': 'Number of visitors',
  'visitSub': 'Number of visitors browsing exhibitors',
  'collected': 'Collection number (number of times)',
  'collectedSub': 'Number of exhibitors being ctolleced (times)',
  'collectedSub2': 'The total number of exhibits being collected',
  'lookNum': 'Number of visitors',
  'lookNumSub': 'The total number of visitors to the exhibit',
  'oppNum': 'The total number of News Feds',
  'oppNumSub': 'The total number of News Feeds sent by exhibitors',
  'commentSum': 'Total number of comments',
  'commentSub': 'The total number of reviews in the  News Feeds',
  'thumbsUp': 'Total likes (number of people)',
  'thumbsUpSub': 'The total number of likes in the News Feeds (total number of people)',
  'inviteNum': 'Total number of invitations received',
  'inviteNumSub': 'The number of exhibitors received active invitations from the audience',
  'IMNum': 'Number of IM interactions',
  'IMNumSub': 'Total number of visitors chatting with exhibitors',
  'unit': 'Person',
  'unit2': 'Times',
  'unit3': 'Piece',
  'unit4': 'Person (times)',
  'unit5': 'Piece',
  'unit6': 'Times (person)',
  'startDate': 'Starting time',
  'endDate': 'Endding Time',
  'collectedActorNum': 'Number of collected exhibitors',
  'collectedActorNumSub': 'Number of exhibitors collected by visitors',
  'collectedExhibitsNum': 'Number of collected exhibits',
  'collectedExhibitsNumSub': 'Number of collected exhibits by visitors',
  'visitActorNum': 'Number of  browse exhibitors',
  'visitActorNumSub': 'Number of visitors browsing exhibitors',
  'visitExhibitNum': 'Number of viewed exhibits',
  'visitExhibitNumSub': 'Number of exhibits viewed by visitors',
  'oppNumVisitorSub': 'The total number of times the audience sent the News Feeds',
  'sendInviteNum': 'Total number of invitations issued',
  'sendInviteNumSub': 'Data volume of visitors actively inviting exhibitors',
  'IMNumVisitSub': 'The total number of exhibitors chatting with the audience',
  'visitorList': 'Audience details',
  'packUp': 'Collapse',
  'uploadTips3': `The upload limit is exceeded, the maximum number of files you can upload is`,

  'linkVisitor': 'Contact',
  'linkActor': 'Contact the exhibitor',
  'productListText': 'Exhibit details',
  'oppListText': 'News Feeds details',
  'inviteListText': 'Invitation details',
  'IMListText': 'IM details',
  'actorListText': 'Exhibitor details',
  'personListText': "Employee details",
  'actorInviteNumSub': 'Number of messages sent by exhibitors to invite visitors',
  'reportPlaceholder': 'Search by exhibit name',
  'reportPlaceholder3': 'Search by keywords in News Feeds',
  // 'reportPlaceholder4': 'Search by employee name, mobile phone number and email',
  'reportPlaceholder4': 'Search by employee name',
  'reportPlaceholder5': 'Search by exhibitor name',
  'reportPlaceholder6': 'Search by exhibitor name and exhibit Name.',
  'dataListSubTitle' : 'Click on the audience details to view the audience details of the corresponding exhibits.',
  'dataListSubTitle2': 'Click on the audience details to view the audience details of the corresponding News Feeds.',
  'dataListSubTitle3': 'Click on the audience details to view the audience details of the corresponding invitation.',
  'dataListSubTitle4': 'Click on the audience details to view the corresponding IM audience Details.',
  'dataListSubTitle5': 'Click on the audience details to view the audience details of the corresponding collected exhibit.',
  'dataListSubTitle6': 'Click on the exhibitor details to view the exhibitor details of the corresponding News Feeds.',
  'dataListSubTitle7': 'Click on the exhibitor details to view the details of the exhibitor details corresponding to the invitation',
  'dataListSubTitle8': 'Click on the employee details to view the employee details of the exhibitors in the corresponding News Feeds',
  'dataListSubTitle9': 'If you want to read the comments, please go to News Feeds management to view',

  'visitorName': "Audience name",
  'company': "Company",
  'post': 'Position',
  'country': 'country',
  'province': 'province',
  'city': 'city',
  'numOfVisits': 'number of views',
  'todoAction': 'operation',
  'productName': 'Exhibit name',
  'numOfVisits2': 'Number of views',
  'numOfCollected': 'Number of favorites',
  'oppContent': 'News Feeds content',
  'oppImgVideo': 'News Feeds Picture / Video',
  'numOfcommented': 'Number of comments',
  'numOfLived': 'Times of likes',
  'collectedNum': 'Number of comments',
  'actorPerson': "Exhibitor's employee",
  'mobile': 'phone number',
  'email': 'E-mail',
  'receivedInviteNum': 'Total number of received invitations',
  'hStatus': 'condition',
  'interactNum': 'Number of interactions',
  'interactPersonNum': 'Number of interactive employees',
  'hActorName': 'Exhibitor name',
  'zoomNum': 'Booth number',
  'hProductName': 'Exhibit name',
  'hProductImgVideo': 'Exhibit Picture/Video',
  'hProductImgVideo2': 'Exhibit Picture',
  'hforActor': 'Beloned Exhibitor',
  'invitePerson': 'Invite employees',
  'lookDetail': "View Details",
  
  'questionTip': 'Please answer the questionnaire carefully so that the target customers who are consistent with your matching degree can find you more quickly and easily',
  'questionTipVisitor': 'The online exhibition platform will accurately match the appropriate target sellers according to the content of the questionnaire you fill in. Please fill in carefully and accurately.',
  'questionTip2': 'The product category you choose can only choose 80 items at most, please choose carefully',
  'questionTip3': ['can only choose ', ' items at most, please choose carefully', 'You ', ' items at most']
}
